import React, { useState } from 'react'
import i18n from './../i18n'
import { useTranslation } from 'react-i18next'

const LanguageSwitch = () => {
  const [lang, setLang] = useState(i18n.resolvedLanguage)
  const { t } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    setLang(lng)
  }
  const img = (code) => (
    <img
      src={
        'https://cdn.openpublishing.com/images/country-flags/' + code + '.png'
      }
      alt={code}
      className="language-flag"
    />
  )
  const flags = {
    en: img('en'),
    de: img('de'),
    fr: img('fr'),
    es: img('es'),
  }

  const flagsItems = Object.keys(flags).map(
    (code) =>
      lang !== code && (
        <li
          key={code}
          className="language"
          onClick={() => changeLanguage(code)}
        >
          {flags[code]}
          {t(code)}
        </li>
      )
  )
  return (
    <div className="language-switch">
      <div className="current-language">{flags[lang]}</div>
      <ul className="other-languages">{flagsItems}</ul>
    </div>
  )
}

export default LanguageSwitch
